import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { StaySummary } from '../../models/stay-summary';
import { OnyxEvent } from '../../models/event';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { MatchTypeEnum } from '../../models/match-type.enum';
import { DecimalPipe } from '@angular/common';
import { AbbreviateAmountPipe } from '../../../shared/pipes/abbreviate-amount.pipe';
import { Party } from 'app/event/models/party';

@Component({
  selector: 'pioneer-header-summary',
  templateUrl: './header-summary.component.html',
  styleUrls: [ './header-summary.component.css' ]
})
export class HeaderSummaryComponent implements OnInit {

  @Input() vendor: Party;

  public onyxEvent: OnyxEvent;
  public headerTitle: string;
  public headerTooltip: string;
  public recordType: SummaryRecordTypeEnum;
  public staySummary: Observable<StaySummary>;
  public matchType: MatchTypeEnum;

  constructor(private compareStore: ReservationCompareStore,
    private decimalPipe: DecimalPipe,
    private abbreviateAmountPipe: AbbreviateAmountPipe) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input('title')
  set title(title: string) {
    this.headerTitle = title;
  }

  @Input('tooltipText')
  set tooltip(tooltip: string) {
    this.headerTooltip = tooltip;
  }

  @Input('type')
  set type(type: SummaryRecordTypeEnum) {
    this.recordType = type;
  }

  @Input('matchType')
  set compareMatchType(matchType: MatchTypeEnum) {
    this.matchType = matchType;
  }

  ngOnInit() {
    if (this.vendor) {
      this.staySummary = this.compareStore.getVendorHeaderSummary(this.vendor.eventPartyId, this.recordType, this.matchType);
    } else {
      this.staySummary = this.compareStore.getHeaderSummary(this.recordType, this.matchType);
    }

  }

  getCommission(revenue: number): number {
    return revenue * this.onyxEvent.eventProperty.commissionRoomPercentage / 100;
  }

  isAbbreviated(amount: number) {
    const decimalFormattedAmount = this.decimalPipe.transform(amount, '1.2-2');
    const abbreviatedAmount = this.abbreviateAmountPipe.transform(amount);
    return decimalFormattedAmount !== abbreviatedAmount;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/header-summary/header-summary.component.ts